export type Dictionary<T = unknown> = {
    [key: string]: T;
};
